import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import isNull from 'lodash/isNull';
import moment from 'moment';
import { TIME_FORMAT } from '../constants/time';
import { APPOINTMENT_TYPE } from '../constants';
import { CARD_TYPE } from '../constants/cardType';
import {
  STEP_MAPPING,
  STEP_ORDERS,
  BACK,
  NEXT,
  BOOKING_ERRORS,
} from '../constants/bookingConstants';

export const generateNextStep = (type, step) => {
  const stepIndex = STEP_ORDERS.indexOf(step);

  const newStepMapping = {
    [BACK]: STEP_ORDERS[stepIndex - 1],
    [NEXT]: STEP_ORDERS[stepIndex + 1],
  };

  const newStep = newStepMapping[type];
  const newRoute = STEP_MAPPING[newStep].route;

  return {
    newStep,
    newRoute,
  };
};

export const removeEmptyStrFields = (fields = {}) =>
  Object.entries(fields).reduce((result, [key, value]) => {
    if (isEmpty(value)) {
      return result;
    }

    return { ...result, [key]: value };
  }, {});

export const validateBookingData = (bookingData) =>
  BOOKING_ERRORS.reduce((errors, { path, error, when }) => {
    if (when && !when(bookingData)) {
      return errors;
    }

    if (!has(bookingData, path)) {
      return [...errors, error];
    }

    return errors;
  }, []);

export const transformData = (
  workflowId,
  bookingData,
  smsTemplateId,
  consent
) => {
  const { appointmentTime, personalDetails, medicare, nextOfKin, bookingInfo } =
    bookingData;
  const { timezone, start, end } = appointmentTime;
  const {
    firstName,
    lastName,
    preferredName,
    dateOfBirth,
    mobile,
    email,
    address,
    suburb,
    state,
    postcode,
  } = personalDetails;
  const {
    cardType = CARD_TYPE.MEDICARE,
    medicareFirstName,
    medicareSurname,
    medicareCardNumber,
    medicareCardIRN,
    expiry,
    dvaNumber,
    dvaCardType,
  } = medicare || {};
  return {
    smsTemplateId,
    workflowId,
    ...(consent ? { consent } : {}),
    appointment: {
      timezone,
      startDateTime: start,
      endDateTime: end,
    },
    client: {
      firstName,
      lastName,
      preferredName,
      dateOfBirth: moment(dateOfBirth).format(TIME_FORMAT.DATE_WITH_DASH),
      mobile: getValidMobilePhoneNumber(mobile),
      email,
      address: {
        streetAddress: address,
        suburb,
        state,
        postCode: postcode,
      },
      medicareCard: {
        cardType,
        medicareFirstName,
        medicareSurname,
        medicareCardNumber,
        medicareCardIRN,
        expiredDate: expiry
          ? moment(expiry).format(TIME_FORMAT.DATE_WITH_DASH)
          : undefined,
        dvaNumber,
        dvaCardType,
      },
      nextOfKin,
      bookingInfo,
    },
  };
};

export const getValidMobilePhoneNumber = (mobileNumber) => {
  if (isNull(mobileNumber)) {
    return null;
  }

  // remove all non-digit characters
  let result = mobileNumber.replace(/\D/g, '');

  if (result.length < 8) {
    return null;
  }

  // get last 8 digits
  result = result.slice(-8);

  return `04${result}`;
};

export const generateAppointmentType = (isNewAppointment) =>
  isNewAppointment ? APPOINTMENT_TYPE.NEW : APPOINTMENT_TYPE.REVIEW;

export const getQuery = (searchSection, key) => {
  const query = new URLSearchParams(searchSection);
  return query.get(key);
};

// patient-api sets appointment.isBooked once the workflow has a booked start
// time; such a patient sees their appointment instead of booking again.
export const isAppointmentBooked = (workflow) =>
  Boolean(workflow?.appointment?.isBooked);
